import { BoundActions, createHook, HookFunction, StoreActionApi } from 'react-sweet-state';

import {
	storeDirectoryView$key,
	ProjectSortEnum,
	GoalSortEnum,
	TimelineDateSpan,
	DirectoryViewUiType,
} from './__generated__/storeDirectoryView.graphql';
import { directoryViewStore } from './store';
import { DirectoryViewDetails } from './types';

export const useDirectoryViewStore: HookFunction<
	DirectoryViewDetails,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore);

export const useDirectoryViewSort: HookFunction<
	ProjectSortEnum[] | GoalSortEnum[] | undefined,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore, {
	selector: directoryView => (directoryView.entityType === 'GOAL' ? directoryView.goalSort : directoryView.projectSort),
});

export const useDirectoryViewTimelineDateSpan: HookFunction<
	TimelineDateSpan | undefined,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore, {
	selector: directoryView => directoryView.timelineDateSpan,
});

export const useDirectoryViewUiViewType: HookFunction<
	DirectoryViewUiType | undefined,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore, {
	selector: directoryView => directoryView.uiViewType,
});

export const useDirectoryViewStoredTql: HookFunction<
	string | undefined,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore, {
	selector: directoryView => directoryView.storedTql,
});

export const useDirectoryViewColumns: HookFunction<
	string[] | undefined,
	BoundActions<
		DirectoryViewDetails,
		{
			setDirectoryView: (
				directoryViewRef: storeDirectoryView$key | undefined | null,
			) => ({ setState }: StoreActionApi<DirectoryViewDetails>) => DirectoryViewDetails;
			clearDirectoryView: () => ({ setState }: StoreActionApi<DirectoryViewDetails>) => void;
		}
	>,
	void
> = createHook(directoryViewStore, {
	selector: directoryView => directoryView.directoryViewColumns,
});
